import React from "react";

import {
  Card,
  CardLabel,
  HelperText,
} from "../../../../components/MobileForm/styles";
import {
  FormInput,
  FormMoneyInput,
  InputDate,
  InstrumentSearch,
} from "../../../../components/Input";
import { localToday } from "../../../../utils";
import { CASHBACK_BUY_AMOUNT_HELPER } from "../constants";
import {
  cashbackCappedAmountRules,
  validateQuantity,
} from "../tradeValidation";
import { MobileCashbackFundingFields } from "../MobileCashbackFundingFields";
import { MobileChargeField } from "../MobileChargeField";
import { MobileNoteField } from "../MobileNoteField";
import { AMOUNT_HELPER, FEE_HELPER, QUANTITY_HELPER } from "./constants";
import { MobileHoldingFormProps } from "./types";

export const MobileHoldingForm: React.FC<MobileHoldingFormProps> = ({
  control,
  minDate,
  dateRules,
  cashback,
  isSubmitting,
}) => {
  return (
    <>
      <Card>
        <CardLabel htmlFor="mobile-holding-instrument">Instrument *</CardLabel>
        <InstrumentSearch
          id="mobile-holding-instrument"
          name="instrument"
          control={control}
          rules={{ required: "Instrument is required!" }}
          disabled={isSubmitting}
        />
        <HelperText>
          Search your ticker catalogue, or request one that isn't in it yet.
        </HelperText>

        <CardLabel htmlFor="mobile-holding-quantity">Quantity *</CardLabel>
        <FormInput
          id="mobile-holding-quantity"
          required
          name="quantity"
          control={control}
          rules={{ validate: validateQuantity }}
          handleClear={false}
          disabled={isSubmitting}
          placeholder="e.g. 12.5"
        />
        <HelperText>{QUANTITY_HELPER}</HelperText>
      </Card>

      <Card>
        <CardLabel htmlFor="mobile-holding-amount">Amount *</CardLabel>
        <FormMoneyInput
          id="mobile-holding-amount"
          required
          name="amountEur"
          control={control}
          rules={cashbackCappedAmountRules}
          disabled={isSubmitting}
          placeholder="0.00"
          variant="title"
        />
        <HelperText>{AMOUNT_HELPER}</HelperText>

        <MobileChargeField
          id="mobile-holding-fee"
          control={control}
          charge="fee"
          helper={FEE_HELPER}
          isSubmitting={isSubmitting}
        />
      </Card>

      {cashback.isShown && (
        <MobileCashbackFundingFields
          idPrefix="mobile-holding"
          control={control}
          sourceOptions={cashback.sourceOptions}
          amountHelper={CASHBACK_BUY_AMOUNT_HELPER}
          isSubmitting={isSubmitting}
        />
      )}

      <Card>
        <CardLabel htmlFor="mobile-holding-date">Trade date *</CardLabel>
        <InputDate
          id="mobile-holding-date"
          name="date"
          control={control}
          rules={dateRules}
          disabled={isSubmitting}
          minDate={minDate}
          maxDate={localToday()}
          placeholder="YYYY/MM/DD"
        />
        <HelperText>Must be on or after the account's start date.</HelperText>
      </Card>

      <Card>
        <MobileNoteField
          id="mobile-holding-note"
          control={control}
          isSubmitting={isSubmitting}
        />
      </Card>
    </>
  );
};
